export const generateTableFields = (list) => list.map(({ label, name }) => {
  return { label, key: name };
});
